// extracted by mini-css-extract-plugin
export default {"texts":"mainComponents_texts__rcX8K","headerSolicitudes":"mainComponents_headerSolicitudes__SZtha"};